export enum FriendshipStatusCode {
  Friend = "FRIEND",
  Inviting = "INVITING",
}
